export const server = process.env.NODE_ENV == "development" ? 'https://localhost:7091' : '';
export const webAPIUrl = `${server}/api`;